<template>
  <div v-if="prices">
    <div v-if="pax && pax.length > 0" style="text-align: right;">
      <h2>{{pax.length}} x {{preparePrice(prices.AmountPax)}} €</h2>
      <h1 style="color: #CCCCCC;font-size: 1rem;">Total <b style="color: #000000;font-size:1.5rem;">
        {{preparePrice(pax.length * prices.AmountPax)}} €</b></h1>
    </div>
    <div v-if="paxData">
      <v-row no-gutters style="text-align: right;">
        <v-col 
          cols="12"
          v-if="paxData.adult"
        >
          <h2>{{paxData.adult}} x {{preparePrice(prices.AmountAdult)}} €</h2>
        </v-col>
        <v-col 
          cols="12"
          v-if="paxData.children"
        >
          <h2>{{paxData.children}} x {{preparePrice(prices.AmountChild)}} €</h2>
        </v-col>
        <v-col 
          cols="12"
          v-if="paxData.baby"
        >
          <h2>{{paxData.baby}} x {{preparePrice(prices.AmountBaby)}} €</h2>
        </v-col>
        <v-col 
          cols="12"
        >
          <h1 style="color: #CCCCCC;font-size: 1rem;">Total <b style="color: #000000;font-size:1.5rem;">
            {{preparePrice(
            (paxData.adult * prices.AmountAdult) +
            (paxData.children * prices.AmountChild) +
            (paxData.baby * prices.AmountBaby) 
            )}} €</b></h1>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    paxData: {
      type: Object,
      default: null,
    },
    pax: {
      type: Array,
      default: null,
    },
    prices: {
      type: Object,
      default: null,
    },
  },
  methods: {
    preparePrice (v) {
      let aux = v.toString().padStart(3, '0')
      let b = aux.substring(aux.length -2, aux.length)
      let a = aux.substring(0, aux.length -2)

      return `${a}.${b}`
    },
  },
}
</script>

